import Header from "./components/Header/Header";
import React, {Component} from "react";
import Main from "./components/Main/Main";
import Eln from "./components/Eln/Eln"
import TrackingReview from "./components/TrackingRev/TrackingReview"
import Ndfl from "./components/Ndfl/Ndfl"
import TSRServices from "./components/Tsr/TSRServices";
import SocialObjects from "./components/Szo/SocialObjects";
import Slider from "./components/Slider/Slider";
import Contacts from "./components/Contacts/Contacts";
import Footer from "./components/Contacts/Footer";
import './App.css';
import LayoutContext from './components/ScrollSpyPagination/LayoutContext';
import Section from "./components/ScrollSpyPagination/Section";
import FSSAdmission from "./components/FssAdmission/FSSAdmission";


class App extends Component {
    render() {
        const styleLayoutColumn = {
            flexDirection: 'column'
        };

        return (
            <div>
                <div className={"sky"}></div>
                <Header/>
                <Main/>
                <LayoutContext.Provider>
                    <div style={styleLayoutColumn}>
                        <Section id={"box-1"} color={''}>
                            <Eln/>
                        </Section>
                        <Section id={"box-2"} color={''}>
                            <TrackingReview/>
                        </Section>
                        <Section id={"box-3"} color={''}>
                            <Ndfl/>
                        </Section>
                        <Section id={"box-4"} color={''}>
                            <TSRServices/>
                        </Section>
                        <Section id={"box-5"} color={''}>
                            <SocialObjects/>
                        </Section>
                        <Section id={"box-6"} color={''}>
                            <Slider/>
                        </Section>
                        {/*<Section id={"box-7"} color={''}>*/}
                        {/*    <FSSAdmission/>*/}
                        {/*</Section>*/}
                        <Section id={"box-7"} color={''}>
                            <Contacts/>
                        </Section>
                        <Footer/>
                    </div>
                </LayoutContext.Provider>
            </div>
        );
    }
}

export default App;

